import * as Sentry from "@sentry/react";

function getEnvironment() {
  const host = window.location.hostname;
  if (host.includes("staging")) {
    return "staging";
  } else if (host.includes("localhost")) {
    return "local";
  } else if (host.includes("mebkit")) {
    return "mebkit";
  } else {
    return "production";
  }
}




Sentry.init({
  dsn: "https://ccdb11aa8e4d4c783484390383eb37f8@o256002.ingest.us.sentry.io/4511142884802560 ",
  ignoreErrors: [
    /Failed to execute 'appendChild' on 'Node': Identifier 'en' has already been declared/i,
    /CSS already injected/i,
    /Failed to execute 'appendChild' on 'Node': Identifier 'ledImages' has already been declared/i,
    /Attempted to focus unregistered tree/i,
  ],
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  environment: getEnvironment(),
  // transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.linkedErrorsIntegration(),
  ],

  // Capture 100% of the transactions. Adjust this value in production as needed.
  tracesSampleRate: 0,

  // Increase the maximum value length so breadcrumbs/strings are not truncated
  maxValueLength: 8192,

  beforeSend(event, hint) {
    const error = hint.originalException;
    // Check if the thrown exception looks like your custom error class framework
    // For custom errors structure check utils/errors.ts
    if (error && typeof error === 'object') {


      // Capture custom `info` parameter as a breadcrumb
      if (error.info) {
        event.breadcrumbs = event.breadcrumbs || [];
        event.breadcrumbs.push({
          category: 'error_info',
          message: 'Additional error information provided',
          level: 'info',
          data: error.info
        });
      }

      // Extra guarantee to grab cause properties if LinkedErrors misses them
      if (error.cause !== undefined) {
        const isObj = typeof error.cause === 'object' && error.cause !== null;
        const causeMessage = isObj && error.cause.message ? error.cause.message : String(error.cause);
        const causeName = isObj && error.cause.name ? error.cause.name : "Unknown";

        event.breadcrumbs = event.breadcrumbs || [];
        event.breadcrumbs.push({
          category: 'original_exception',
          message: `${causeName}: ${causeMessage}`,
          level: 'error',
          data: {
            error_name: causeName,
            error_details: causeMessage
          }
        });
      }
    }
    return event;
  }
});
